module.exports = __webpack_public_path__ + "img/Mage-troll-m-70.5856b92e.gif";